import React, {useState, useEffect} from 'react';
import {t, getLanguage} from 'react-switch-lang';
import {
  getAllProcesses,
  getAllSubProcesses,
  getAllDepartments,
  getKriReport,
} from '../../services/reports/kriReport';
import FormatList from './reportForm/components/format/FormatList';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import {useUserContext} from '../../contexts/UserContext';
import SelectList from '../../components/FormFields/Select';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import {format} from 'date-fns';
import './Report.scss';
import Toast from '../../components/toast/Toast';

const KriReport2 = (props) => {
  const type = '';
  const isValidType = '';
  const customApi = 'api';
  const lang = getLanguage();
  const [selectedFormat, setSelectedFormat] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [query, setQuery] = useState();
  const [processes, setProcesses] = useState([]);
  const [subProcesses, setSubProcesses] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [format2, setFormat2] = useState('');
  const [apiParameters, setApiParameters] = useState([]);

  const fetchProcesses = async () => {
    try {
      const {data} = await getAllProcesses();
      setProcesses(data);
      return data;
    } catch (e) {}
  };

  const fetchDepartments = async () => {
    try {
      const {data} = await getAllDepartments();
      setDepartments(data);
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    fetchProcesses().then((r) => {
      let processes = [];
      r.forEach((item) => {
        processes.push(
          lang === 'eng'
            ? {value: item.id, label: item.nameEn}
            : {
                value: item.id,
                label: item.name,
              }
        );
      });

      setProcesses(processes);
    });

    fetchDepartments().then((r) => {
      let departments = [];
      r.forEach((item) => {
        departments.push(
          lang === 'eng'
            ? {value: item.id, label: item.nameEn}
            : {
                value: item.id,
                label: item.name,
              }
        );
      });

      setDepartments(departments);
    });
  }, []);

  const schema = yup.object().shape({
    process: yup.object().nullable().required(t('message.fieldRequired')),
    subprocess: yup.object().nullable().required(t('message.fieldRequired')),
    department: yup.object().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, reset, errors, setValue} = methods;
  const processSelected = watch('process');
  let validFrom = watch('startDate');
  let validTo = watch('endDate');

  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(processSelected['value']);
      setSubProcesses(data);
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    if (processSelected) {
      fetchSubprocesses().then((r) => {
        let subProcesses = [];
        r.forEach((item) => {
          subProcesses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubProcesses(subProcesses);
      });
    }

    if (processSelected === null) {
      setValue('subprocess', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [processSelected]);

  const user = useUserContext();

  let userRiskSector = false;
  let responsibleUser = false;
  let userInCharge = false;

  user.authorities.forEach((item) => {
    if (item === 'ROLE_RISK_SECTOR') {
      userRiskSector = true;
    }
    if (item === 'ROLE_RESPONSIBLE_USER') {
      responsibleUser = true;
    }
    if (item === 'ROLE_USER_IN_CHARGE') {
      userInCharge = true;
    }
  });

  useEffect(() => {
    setSelectedFormat();
    setIsSubmitted(false);
  }, []);

  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
          <div className="form-group pr-5">
              <label className="label" htmlFor="startDate">
                {t('reports.dateFrom')}
              </label>
              <InputDate
                name="startDate"
                defaultValue={new Date()}
                className={`date-height form-control ${
                  validFrom === null && isSubmitted === true ? `error-field` : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateFrom')}
              />
              {
                validFrom === null && isSubmitted === true
              ? <span className="error-message position-absolute">{t('message.fieldRequired')}</span>
                : ''
              }
            </div>
            <FormatList
              isValidType={isValidType}
              value={['PDF', 'XLSX']}
              parameterName="format"
              onChange={(e) => setFormat2(e)}
              isSubmitted={isSubmitted}
              setIsSubmitted={() => setIsSubmitted(false)}
              setSelectedFormat={(e) => setSelectedFormat(e.toLowerCase())}
              error={!format2.length > 0}
            />
            <DownloadBtn
              api={'key-indicators/key-indicator-report'}
              paramsLength={2}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              apiParameters={{
                date:
                validFrom !== null && validFrom !== undefined
                  ? `date=${encodeURIComponent(
                      format(validFrom, 'yyyy-MM-dd')
                    )  + 'T' + format(validFrom, 'hh:mm:ss')}`
                  : '',
                format: format2,
              }}
            />
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default KriReport2;
